import clsx from 'clsx';

import styles from './HomeLayout.module.scss';

interface ComponentProps {
  children: React.ReactNode;
  className?: string;
}

export const HomeLayout = ({ children, className }: ComponentProps) => {
  return (
    <main className={styles.layout}>
      <div className={clsx(styles.container, className)}>{children}</div>
    </main>
  );
};
